export const agentBuilderStyles = {
  builderContainer: {
    display: 'flex',
    gap: '24px',
    background: 'rgba(124, 58, 237, 0.02)',
    borderRadius: '16px',
    border: '1px solid rgba(124, 58, 237, 0.1)',
    overflow: 'hidden',
    minHeight: '600px'
  },
  builderSidebar: {
    width: '280px',
    background: 'rgba(124, 58, 237, 0.05)',
    borderRight: '1px solid rgba(124, 58, 237, 0.2)',
    padding: '24px'
  },
  builderSidebarTitle: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#ffffff'
  },
  componentsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  componentItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    background: 'rgba(124, 58, 237, 0.1)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '8px',
    cursor: 'grab',
    transition: 'all 0.3s',
    fontSize: '14px',
    color: '#d1d5db'
  },
  builderCanvas: {
    flex: 1,
    padding: '24px',
    background: 'rgba(15, 8, 23, 0.5)',
    position: 'relative'
  },
  canvasHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    paddingBottom: '16px',
    borderBottom: '1px solid rgba(124, 58, 237, 0.2)'
  },
  canvasTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#ffffff'
  },
  canvasActions: {
    display: 'flex',
    gap: '8px'
  },
  canvasButton: {
    padding: '8px 16px',
    background: 'transparent',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '6px',
    color: '#8b5cf6',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  canvasButtonPrimary: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg, #7c3aed, #8b5cf6)',
    border: 'none',
    borderRadius: '6px',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  flowContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '32px',
    flexWrap: 'wrap'
  },
  flowNode: {
    background: 'rgba(124, 58, 237, 0.1)',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '12px',
    padding: '16px',
    minWidth: '180px',
    flex: '1'
  },
  nodeHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#8b5cf6'
  },
  nodeBody: {
    fontSize: '12px',
    color: '#cccccc',
    lineHeight: 1.4
  },
  flowArrow: {
    fontSize: '20px',
    color: '#8b5cf6',
    fontWeight: 'bold'
  },
  configPanel: {
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '12px',
    padding: '20px'
  },
  configTitle: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#ffffff'
  },
  configGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '16px'
  },
  configItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  configLabel: {
    fontSize: '12px',
    color: '#8b5cf6',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  configInput: {
    padding: '8px 12px',
    background: 'rgba(124, 58, 237, 0.1)',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '6px',
    color: '#ffffff',
    fontSize: '14px',
    outline: 'none'
  },
  configTextarea: {
    padding: '8px 12px',
    background: 'rgba(124, 58, 237, 0.1)',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '6px',
    color: '#ffffff',
    fontSize: '14px',
    outline: 'none',
    minHeight: '80px',
    resize: 'vertical'
  }
};